const { OrderSummary, OrderSummaryItem } = require('../models/order-summary');
const { discountMapper } = require('./discount.mapper');
const { packageMapper } = require('./package.mapper');

/**
 * Map to order summary from dto.
 * @param {object} dto Dto.
 * @returns {OrderSummary}
 */
function fromDto(dto) {
  return new OrderSummary({
    total: dto.total,
    items: dto.items.map(item => new OrderSummaryItem({
      amount: item.amount,
      discountCode: item.discount_code,
      package: packageMapper.fromDto(item.package),
      packageId: item.package_id,
      price: item.price,
      quantity: item.qty,
      discountCustomAmount: item.discount_custom_amount,
      stateCode: item?.state_code || '',
      isFreeFoodHandlerCard: item.is_free_food_handler_card ?? false,
    })),
    discounts: dto.discounts.map(discount => discountMapper.fromDto(discount)),
  });
}

/**
 * Map to dto.
 * @param {object} data Data.
 * @param {Array} data.packages Packages.
 * @param {Array} data.discounts Discounts.
 * @param {boolean} data.isCorporateDiscount Whether order apply corporate discount.
 * @param {boolean} data.isPayByCheck Whether order paid by check.
 * @param {boolean} data.isWithZeroCheck Whether order mark as pay later or not. If true => pay later (create order with unpaid status), else, create order with paid status (used with order with price 0).
 * @param {boolean} data.corporateCode Corporate code.
 * @param {boolean} data.isAllowAssign Allow Assign for Corporate code.
 * @returns {object}
 */
function toDto(data) {
  return {
    items: data.packages.map(p => ({
      package_id: p.id,
      qty: p.quantity,
      is_corporate_discount: p.isCorporateDiscount ?? false,
      remember_exam_language_id: p.rememberExamLanguageId ?? undefined,
      remember_class_id: p.rememberClassId ?? undefined,
      discount_custom_amount: p.discountCustomAmount,
      state_code: p.stateCode ?? '',
    })),
    discounts: data.discounts.map(discount => ({
      code: discount,
      is_corporate_discount: data.isCorporateDiscount ?? false,
    })),
    pay_by_check: data.isPayByCheck,
    corporate_code: data.corporateCode,
    with_zero_check: data.isWithZeroCheck,
    allow_assign: data.isAllowAssign,
  };
}

export const orderSummaryMapper = {
  fromDto,
  toDto,
};
